"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductClickError = void 0;
/**
 * <h4>Product click send Error</h4>
 *
 * An error can be thrown from {@link sendProductClick} invocation
 */
var ProductClickError = /** @class */ (function (_super) {
    __extends(ProductClickError, _super);
    function ProductClickError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ProductClickError.prototype);
        return _this;
    }
    return ProductClickError;
}(Error));
exports.ProductClickError = ProductClickError;
//# sourceMappingURL=ProductClickError.js.map